import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

import moduleAccount from '@account/store'
import moduleBigfile from '@bigfile/store'
import moduleRecipient from '@recipient/store'

Vue.use(Vuex)

const state: RootState = {  
    paneLoading: false,
    currentItem: null,
    validDomain: [],
    originalRecipients: [],
    indexedRecipients: [],
    recipientsWithStatus: [],
    searchTargetList: []    
}

export default new Vuex.Store<RootState>({
    state,
    actions,
    getters,
    mutations,
    modules: {
        $account: moduleAccount,
        $bigfile: moduleBigfile,
        $recipient: moduleRecipient
    }
})
